export default {
  bot: 'Bot',
  agent: 'Attendant',
  sequential_id: 'Ticket',
  customer_name: 'Customer',
  queue_time: 'Time in Queue',
  first_response_time: 'First Response',
  attendance_time: 'Attendance Time',
};
